import { render, staticRenderFns } from "./PowerpageComponent.vue?vue&type=template&id=36b29d5d&scoped=true&"
import script from "./PowerpageComponent.vue?vue&type=script&lang=js&"
export * from "./PowerpageComponent.vue?vue&type=script&lang=js&"
import style0 from "./PowerpageComponent.vue?vue&type=style&index=0&id=36b29d5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b29d5d",
  null
  
)

export default component.exports